import React, { useEffect } from 'react';
import { ComposedModal, ModalBody } from 'carbon-components-react';
import CloseButton from '../close-button/CloseButton';
import { Icon } from '../../facades';
/**
 * `Modal` is a component that displays a dialog window that sits on top of the page content.
 * For the body and footer, you are able to pass React nodes to give full customization of your modal design.
 * It requires a `header` and a `onClose` function that deals with closing the modal window. The modal's ability to open/close is
 * all handled in a single prop called `open` which takes in a boolean value.
 * The modal handles the close function in a couple of ways. You can either pass a component in the body/footer that handles the `onClose` function,
 * click outside of the modal component, or triggering the close with an `ESC` key.
 *
 * `headerAdornmentIcon` takes fontAwesome classes.
 *
 * To import the component use the import statement: `import { Modal } from '@asuresoftware/asure.design-system'`
 */
export var Modal = function (props) {
    var icon = props.headerAdornmentIcon;
    var mobileFullScreen = props.mobileFullScreen ? ' mobile-full-screen' : '';
    var propsClassName = props.className ? " " + props.className : '';
    useEffect(function () {
        function handleEscape(event) {
            if (event.key === 'Escape') {
                props.onClose();
            }
        }
        document.addEventListener('keyup', handleEscape);
        return function () {
            document.removeEventListener('keyup', handleEscape);
        };
    }, [props]);
    return (React.createElement(ComposedModal, { "data-testid": "modal", ref: props.ref, open: props.open, onClose: props.onClose, className: "ac-modal" + mobileFullScreen + propsClassName, size: props.size },
        React.createElement("header", { className: "d-flex justify-content-between" },
            React.createElement("div", { className: "d-flex" },
                props.headerAdornmentIcon && React.createElement(Icon, { color: props.headerAdornmentIconColor, className: "ac-modal-header-adornment", icon: icon, lib: "fal" }),
                React.createElement("h1", null, props.header)),
            React.createElement(CloseButton, { textColor: "text-dark", className: "ac-modal-close-button ml-3", size: "md", onClick: props.onClose })),
        React.createElement(ModalBody, { "data-testid": "modal-detail", hasScrollingContent: props.hasScrollingContent, "aria-label": props.hasScrollingContent && 'modal-body' }, props.children),
        props.footerContent && React.createElement("footer", null, props.footerContent)));
};
export default Modal;
//# sourceMappingURL=Modal.js.map